import { compact, flatten, get, includes, isEmpty, keyBy, map, mapValues, replace, split } from "lodash"

const customOrderByVariables = (sorted, formatVariable) =>
  flatten(
    map(sorted, sortItem => {
      if (formatVariable) return formatVariable(sortItem)
      return sortItem
    })
  )

const additionalPropsVariablesMapping = (propertyMapping, sorted, pathPrefix = "") => {
  return map(sorted, sortItem => {
    const { path } = sortItem
    if (includes(path, "additionalProps")) {
      const additionalPropsPathPrefix = pathPrefix
        ? replace(pathPrefix, "additionalProperties", "additionalProps.")
        : "additionalProps."
      const [propertyName, propertyValue] = split(
        replace(path, additionalPropsPathPrefix, ""),
        "."
      )

      const columnItem = get(propertyMapping, propertyName)

      return {
        ...sortItem,
        path: `additionalProps.${columnItem}.${propertyValue}`,
      }
    }
    return sortItem
  })
}

export const getOrderByAdditionalProps = (propertyMapping, formatVariable, pathPrefix) => sorted =>
  additionalPropsVariablesMapping(propertyMapping, customOrderByVariables(sorted, formatVariable), pathPrefix)

export const getWhereAdditionalProps = (propertyMapping, formatVariable, pathPrefix) => filtered =>
  compact(
    map(additionalPropsVariablesMapping(propertyMapping, filtered, pathPrefix), whereItem => {
      if (formatVariable) return formatVariable(whereItem)
      return whereItem
    })
  )

export const mergeAdditionalPropsInItem = (item, name, propertyTypes) => ({
  ...item,
  additionalProps: keyBy(
    map(get(item, name), additionalProp => ({
      ...additionalProp,
      propertyName: get(get(propertyTypes, get(additionalProp, "propertyId")), "propertyName"),
    })),
    "propertyName"
  ),
})

export const mergeProcessItemsAdditionalProps = (items, propertyTypes, name) => {
  if (isEmpty(propertyTypes)) {
    return items
  }

  return map(items, item => mergeAdditionalPropsInItem(item, name, propertyTypes))
}

// Merges all possible properties in the item, those that have a value and those that don't
export const mergeAllAdditionalProps = (item, name, propertyTypes) => {
  const propertyTypesByName = keyBy(propertyTypes, "propertyName")
  const existingProps = keyBy(get(item, name, []), "propertyId")
  const additionalProps = mapValues(propertyTypesByName, ({ propertyName, id }) => ({
    propertyName,
    propertyId: id,
    value: get(existingProps, `[${id}].value`, null),
  }))

  return {
    ...item,
    additionalProps,
  }
}
